<template>

    <div class="py-4 container-fluid">
      <div class="row">


        <div class="col-md-8">
          <div class="card mb-2">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Crear Producto</p>
                <argon-button  color="success" size="sm" class="ms-auto"  @click="save"
                  >Guardar</argon-button>
              </div>
            </div>
            <div class="card-body">
              <p class="text-uppercase text-sm">Información</p>
              <div class="row">
                <div class="col-md-8">
                  <label for="example-text-input" class="form-control-label"
                    >Nombre</label>
                  <argon-input type="text"  v-model="form.name"/>
                </div>

               <div class="col-md-4">
                  <label for="example-text-input" class="form-control-label"
                    >Referencia</label>
                  <argon-input type="text"  v-model="form.ref"/>
                </div>

                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Descripción</label>
                    <argon-textarea type="text"  v-model="form.description"/>
                </div>

                <div class="col-md-4" >
                  <label for="supply-stock-input" class="form-control-label"
                    >Stock</label>
                  <input
                    id="supply-stock-input"
                    type="number"
                    class="form-control"
                    min="0"
                    step="1"
                    inputmode="numeric"
                    v-model.number="form.quantity"
                    @blur="normalizeStockQuantity"
                  />
                </div>

                <div class="col-md-4" >
                  <label for="example-text-input" class="form-control-label"
                    >Precio de compra</label>
                  <argon-input type="text"  v-model="form.price"/>
                </div>

                 <div class="col-md-4" >
                  <label for="example-text-input" class="form-control-label"
                    >Precio de Venta</label>
                  <argon-input type="text"  v-model="form.sale_price"/>
                </div>

                <div class="col-md-12">
                  <label class="form-control-label text-dark mb-1">
                    Estos campos se usan como semaforo de stock:
                    Minima, Media y Alta.
                  </label>
                </div>

                <div class="col-md-4">
                  <label for="example-text-input" class="form-control-label"
                    ><span class="semaphore-dot dot-red"></span>Cant mininima</label>
                  <argon-input type="text"  v-model="form.low"/>
                </div>

                <div class="col-md-4">
                  <label for="example-text-input" class="form-control-label"
                    ><span class="semaphore-dot dot-yellow"></span>Cant media</label>
                  <argon-input type="text"  v-model="form.medium"/>
                </div>

                <div class="col-md-4">
                  <label for="example-text-input" class="form-control-label"
                    ><span class="semaphore-dot dot-green"></span>Cant alta</label>
                  <argon-input type="text"  v-model="form.high"/>
                </div>


                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Bodega</label
                  >
                  <select name="" id="" class="form-select" v-model="form.bodega_id">
                    <option value="">Seleccionar</option>
                    <option v-for="bodega in bodegas" :key="bodega.id" :value="bodega.id">
                        {{ bodega.name }}
                      </option>
                  </select>
                </div>

                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Estado</label
                  >
                  <select name="" id="" class="form-select" v-model="form.status">
                    <option value="0">Inactivo</option>
                    <option value="1">Activo</option>
                  </select>
                </div>

                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Categorías</label
                  >
                  <select ref="categoriesSelect" class="form-select" multiple>
                    <option v-for="category in categories" :key="category.id" :value="category.id">
                        {{ category.fullname || category.name }}
                      </option>
                  </select>
                </div>
               
              </div>
            </div>
          </div>

        </div>

        <div class="col-md-4" v-if="form.id !== 0">
          <div class="card mb-2">
            <div class="card-header pb-0">
              <p class="mb-0">Imágenes del Producto</p>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <label class="form-control-label d-block">Agregar imagen</label>
                  <input
                    class="form-control"
                    type="file"
                    id="fileProductImage"
                    accept="image/*;capture=camera"
                    @change="saveImage($event)"
                    :disabled="uploadingImage"
                  />
                  <small v-if="uploadingImage" class="text-muted">Subiendo imagen...</small>
                </div>
              </div>

              <div v-if="productImages.length > 0" class="mt-2">
                <div
                  v-for="img in productImages"
                  :key="img.id"
                  class="position-relative mb-3"
                >
                  <img
                    :src="apiUrl + img.file_path"
                    alt="Imagen del producto"
                    class="img-fluid rounded"
                    style="max-width: 100%; height: auto;"
                  />
                  <div class="mt-1">
                    <a
                      @click="deleteImage(img.id)"
                      class="text-danger font-weight-bold text-xs cursor-pointer"
                    >
                      <i class="fa fa-trash"></i> Eliminar
                    </a>
                  </div>
                </div>
              </div>
              <p v-else class="text-center mt-2 text-muted">No hay imágenes disponibles.</p>
            </div>
          </div>
        </div>

  

      </div>

  
  </div>

</template>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import 'select2/dist/css/select2.css';
import 'select2';
import $ from 'jquery';
const body = document.getElementsByTagName("body")[0];

export default {
  name: "Models Create",
  data() {
    return {
      showMenu: false,
      form: {
        id:0,
        name: '',
        ref:'',
        description:'',
        quantity: 0,
        status: 1,
        bodega_id:0,
        price:0,
        low:0,
        medium:0,
        high:0,
        sale_price:0,
        categories:[],
      },
      bodegas:[],
      categories: [],
      users: [],
      data: {},
      productImages: [],
      uploadingImage: false,
      apiUrl: process.env.VUE_APP_API_IMAGE_URL || process.env.VUE_APP_API_BASE_URL,
    };
  },
  components: { ArgonInput,ArgonTextarea, ArgonButton },
  computed: {
  },
  watch: {
    'form.name'(newName) {
      const value = String(newName || '')
        .trim()
        .replace(/\s+/g, '-');
      this.form.ref = value;
    },
  },
  methods: {
    normalizeStockQuantity() {
      const n = Math.round(Number(this.form.quantity));
      this.form.quantity = Number.isFinite(n) && n >= 0 ? n : 0;
    },
    async getBodegas() {
      this.bodegas = await this.$store.dispatch('bodegas/getAll'); 
    },
    async getCategories() {
      const response = await this.$store.dispatch('categories/getCategories');
      this.categories = response.data;
      this.$nextTick(() => this.initCategoriesSelect());
    },
    initCategoriesSelect() {
      $(this.$refs.categoriesSelect).select2({
        placeholder: 'Seleccione las categorías del producto',
        allowClear: true,
      });
      // Actualizar el valor cuando se seleccione una opción en select2
      $(this.$refs.categoriesSelect).on('change', () => {
        this.form.categories = $(this.$refs.categoriesSelect).val() || [];
      });
      // Aplicar la selección inicial (modo edición)
      $(this.$refs.categoriesSelect).val(this.form.categories).trigger('change');
    },
    async save() {
      try {
        const wasNewRecord = Number(this.form.id) === 0;
        this.normalizeStockQuantity();
        const formToSave = {
          ...this.form,
          quantity: Math.max(0, Math.round(Number(this.form.quantity) || 0)),
        };
        // Dispara la acción de Vuex para guardar el producto
        const response = await this.$store.dispatch("inventory/save", formToSave);
        if (response && response.status >= 200 && response.status < 300) {
          // Si es un nuevo producto, actualizar el ID para poder subir imágenes
          if (wasNewRecord) {
            this.form.id = response.data.id;
          }
          
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El producto ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
              if (result.isConfirmed) {
                // Si hay una imagen seleccionada pero no se ha subido, intentar subirla
                const fileInput = document.getElementById("fileProductImage");
                if (fileInput && fileInput.files.length > 0) {
                  this.saveImage();
                } else if (wasNewRecord) {
                  // producto nuevo guardado, mostrar card de imágenes
                } else {
                  this.$router.push({ name: "Supplies" });
                }
              }
          });

        }else{
          throw new Error(response.data.message || 'Error al guardar el producto');
        }

      } catch (error) {
        console.error("Error al crear el producto:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el producto',
        });
      }
    },
    async saveImage(event = null) {
      try {
        if (this.form.id === 0) {
          Swal.fire('Advertencia', 'Debe guardar el producto primero antes de subir la imagen', 'warning');
          return;
        }

        const eventInput = event?.target;
        const fallbackInput = document.getElementById("fileProductImage");
        const fileInput = eventInput || fallbackInput;
        if (!fileInput || !fileInput.files[0]) {
          Swal.fire('Advertencia', 'Por favor seleccione una imagen', 'warning');
          return;
        }

        const file = fileInput.files[0];
        this.uploadingImage = true;

        const formData = new FormData();
        formData.append("mediaable_id", this.form.id);
        formData.append("mediaable_type", 'inventory');
        formData.append("file", file);

        const response = await this.$store.dispatch("media/save", formData);
        if (response && response.status >= 200 && response.status < 300) {
          await this.getImage();
          fileInput.value = '';
          try {
            await this.$store.dispatch("inventory/syncWordPress", this.form.id);
          } catch (_) {
            // sync silencioso, no bloquea al usuario
          }
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'La imagen ha sido subida correctamente.',
              confirmButtonText: 'Aceptar',
              timer: 1500,
              showConfirmButton: false,
          });
        } else {
          throw new Error(response.data.message || 'Error al subir la imagen');
        }

      } catch (error) {
        console.error("Error al subir la imagen:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al subir la imagen',
        });
      } finally {
        this.uploadingImage = false;
      }
    },
    async getImage() {
      if (this.form.id && this.form.id !== 0) {
        try {
          const media = await this.$store.dispatch('media/getData', this.form.id);
          if (media && media.data) {
            const list = Array.isArray(media.data) ? media.data : media.data.data || [];
            this.productImages = list.filter(item => item.mediaable_type === 'inventory');
          }
        } catch (error) {
          console.error("Error al obtener las imágenes:", error);
        }
      }
    },
    async deleteImage(imageId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción eliminará la imagen del producto.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          await this.$store.dispatch("media/delete", imageId);
          this.productImages = this.productImages.filter(img => img.id !== imageId);
          await Swal.fire('Eliminado!', 'La imagen ha sido eliminada correctamente.', 'success');
        }
      } catch (error) {
        console.error("Error al eliminar la imagen:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar la imagen',
        });
      }
    },  
  },
  mounted() {

    this.getBodegas();

    const route = useRoute();
    const dataEdit = route.params.data;

    console.log(dataEdit);

    if (dataEdit) {
        try {
            const params = JSON.parse(dataEdit); // Asegúrate de que este JSON se pueda parsear

            
            if (params && params.id) {

              this.form = params;
              this.normalizeStockQuantity();
              // Cargar la imagen del producto si existe
              this.getImage();
              // Normalizar las categorías a un arreglo de ids
              this.form.categories = (params.categories || []).map((category) => category.id ? category.id : category);

            }
        } catch (error) {
            console.error("Error al parsear los datos del registro:", error);
        }
    }

    this.getCategories();

    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.semaphore-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: middle;
}

.dot-red {
  background-color: #dc3545;
}

.dot-yellow {
  background-color: #ffc107;
}

.dot-green {
  background-color: #28a745;
}

.disabled-link {
  color: gray;
  pointer-events: none; /* Impide la interacción */
  cursor: not-allowed; /* Cambia el cursor para indicar que está deshabilitado */
}
</style>


